import setupContactFormPhoneValidationElement from './formPhoneValidation';
import formCrm from './formCrm';
import formNewsletter from './formNewsletter';

// forms
let crmForm;
let newsletterForm;

// Recaptcha
let recaptchaValid = false;

// Add phone helper.
let iti = null;

// setup form phone validation.
function setupContactFormPhoneValidation() {
  const phoneNumberElement = document.querySelector('.js-contact-form__phone-number');
  if (phoneNumberElement) {
    iti = setupContactFormPhoneValidationElement(crmForm.fields.phoneNumber.elem);
  }
}

// Disables a collection of form-elements.
function disableElements(elements) {
  for (let i = 0; i < elements.length; i += 1) {
    const element = elements[i];
    element.disabled = true;
  }
}

// Enable a collection of form-elements.
function enableElements(elements) {
  for (let i = 0; i < elements.length; i += 1) {
    const element = elements[i];
    element.disabled = false;
  }
}

// Disables a form.
function disableFormElements(form) {
  const inputs = form.getElementsByTagName('input');
  const textareas = form.getElementsByTagName('textarea');
  const buttons = form.getElementsByTagName('button');
  const selects = form.getElementsByTagName('select');

  disableElements(inputs);
  disableElements(textareas);
  disableElements(buttons);
  disableElements(selects);
}

// Enable a form.
function enableFormElements(form) {
  const inputs = form.getElementsByTagName('input');
  const textareas = form.getElementsByTagName('textarea');
  const buttons = form.getElementsByTagName('button');
  const selects = form.getElementsByTagName('select');

  enableElements(inputs);
  enableElements(textareas);
  enableElements(buttons);
  enableElements(selects);
}

function submitFormViaAjax(formToProcess) {
  const form = formToProcess;
  const $formElem = form.elem;
  let action = $formElem.getAttribute('action');
  const method = $formElem.getAttribute('method');

  // used for the newsletter form.
  if (method.toLowerCase() !== 'post') {
    action += '?callback=?';
  }

  const currentFormData = new FormData($formElem);
  // if there is a phone number get the full number.
  Object.keys(form.fields).forEach((key) => {
    const value = form.fields[key];
    if (value.type && value.type === 'phone') {
      if (iti) {
        const phoneNumber = iti.getNumber().replace('+', '');
        currentFormData.set('phoneNumber', phoneNumber);
      }
    }
  });

  const jsonRequest = {
    url: action,
    type: method,
    data: currentFormData,
    processData: false,
    contentType: false,
  };

  if (form.json) {
    jsonRequest.dataType = 'json';
  }

  fetch(action, {
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
    },
    method,
    body: currentFormData,
  })
    .then((response) => response.json())
    .then((data) => {
      console.log(data);

      // Newsletter
      if (form.name === 'newsletter') {
        if (data.status === 400) {
          alert(`Error: ${data.Message}`);
        } else { // 200
          form.elem.style.display = 'none';
          form.elemConfirm.style.display = 'block';
        }

        // Contact
      } else if (form.name === 'contact') {
        // error
        if (data.status === 400) {
          // Todo: add proper error message.
          alert(`Error: ${data.Message}`);
          // success
        } else if (data.success === true) {
          form.elem.style.display = 'none';
          form.elemConfirm.style.display = 'block';

          // eslint-disable-next-line no-param-reassign
          document.querySelectorAll('.hide-on-success-form-submit').forEach((el) => { el.style.display = 'none'; });

          // error
        } else if (typeof data.error === 'object') {
          const formErrorElem = form.errorElem;
          // iterate over errors.

          // Todo: this seems wrong and would only show the last error.
          let errorMessages = '';
          Object.keys(data.error).forEach((errorId) => {
            errorMessages += data.error[errorId];
          });
          formErrorElem.textContent = errorMessages;

          // show error message.
          // formErrorElem.style.display = 'block';

          // remove form transparent.
          form.elem.classList.remove('disabled');

          enableFormElements(form.elem);
          document.querySelector('.js_crm-form-loading').style.display = 'none';

          console.log(data.error);

          // serious error
        } else {
          console.log(data);
          alert('A form error occurred!');
        }
      }
    })
    .catch((error) => {
      console.log('error', error);
    });
}

// Check if form fields, phone number, and recaptcha is valid.
function validateForm(form) {
  let valid = true;

  // validate all fields, except phone number.
  Object.keys(form.fields).forEach((key) => {
    const field = form.fields[key];

    if (
      field.type !== 'phone' // skip phone numbers
      && !field.valid
      && !(
        field.optionalOnPage === true
        && field.elem.length === 0 // Not on page
      )
    ) {
      valid = false;
      field.elem.classList.add('is-invalid');
      if (field.errorElem !== null) {
        field.errorElem.textContent = field.errorMessage;
      }
    }
  });

  // validate phone seperate since it uses iti.
  if (form.fields.phone) { // form has a phone number
    const field = form.fields.phone;

    if (
      // if optional, field have a value, and test is not valid.
      (
        (
          field.optionalOnPage === true
          && field.elem.value.trim().length > 0
        )
        || field.optionalOnPage !== true
      )
      && !iti.isValidNumber()
    ) {
      console.log(iti.getValidationError());
      valid = false;
      field.elem.classList.add('is-invalid');
      if (field.errorElem !== null) {
        field.errorElem.textContent = field.errorMessage;
      }
    }
  }

  // test reCatchta
  if (crmForm.recaptcha === 'V2') {
    const recaptchaErrorElement = document.querySelector('.js-contact-form__error--recaptcha');

    if (recaptchaValid === false) {
      // Add error message
      const recaptchaErrorMessage = recaptchaErrorElement.dataset.errorMessage;
      recaptchaErrorElement.textContent = recaptchaErrorMessage;
      recaptchaErrorElement.classList.add('is-invalid');
      valid = false;
    } else {
      recaptchaErrorElement.textContent = '';
      recaptchaErrorElement.classList.remove('is-invalid');
    }
  }

  return valid;
}

function submitForm(e, form) {
  const valid = validateForm(form);

  if (!valid) {
    e.preventDefault();

    // show general error message.
    if (form.errorElem) {
      // eslint-disable-next-line no-param-reassign
      form.errorElem.textContent = form.errorMessage;
    }
  } else {
    if (form.ajax) {
      e.preventDefault();
      submitFormViaAjax(form);
    }

    // disable form
    disableFormElements(form.elem[0]);

    // make form transperant.
    form.elem.classList.add('disabled');

    // show loading
    document.querySelector('.js_crm-form-loading').style.display = 'block';

    // get form id, and send a flood light.
    const formIdEl = document.getElementById('form_id');
    if (formIdEl && formIdEl.value) {
      const formIdElValue = formIdEl.value;

      try {
        window.dataLayer.push = ({
          event: 'cmr_form_complete',
          form_id: formIdElValue,
        });
      } catch (error) {
        console.log(error);
      }
    }

    const download = form.elem.getAttribute('data-download');
    if (download) {
      // window.location = download;
      download(download);
    }
  }
}

// Todo Add phone number validation on input.
function validateInput(e) {
  const formKey = e.key;
  const formFields = e.obj;
  const field = formFields[formKey];
  const $fieldElement = field.elem;

  console.log($fieldElement.id);
  if ($fieldElement.validity.valid) {
    field.valid = true;
    if (field.errorElem !== null) {
      field.errorElem.textContent = '';
    }
    $fieldElement.classList.remove('is-invalid');
  } else {
    field.valid = false;
    if (field.errorElem !== null) {
      field.errorElem.textContent = field.errorMessage;
    }
    $fieldElement.classList.add('is-invalid');
  }
}

function validatePhoneNumber(e) {
  const formKey = e.key;
  const formFields = e.obj;
  const field = formFields[formKey];
  const $fieldElement = field.elem;

  console.log($fieldElement.id);
  if (
    (
      (
        field.optionalOnPage === true // is optional
        && field.elem.value.trim().length > 0 // has a value
      )
      || field.optionalOnPage !== true // not optional
    )
    && !iti.isValidNumber() // test is not valid
  ) {
    // show error message.
    field.valid = false;
    if (field.errorElem !== null) {
      field.errorElem.textContent = field.errorMessage;
    }
    $fieldElement.classList.add('is-invalid');
  } else {
    // clear error message if there is one.
    field.valid = true;
    if (field.errorElem !== null) {
      field.errorElem.textContent = '';
    }
    $fieldElement.classList.remove('is-invalid');
  }
}

function setFormId() {
  const formIdElement = document.getElementById('formId');
  if (!formIdElement) {
    return;
  }

  const currentFormData = new FormData();
  currentFormData.set('action', 'crmForm/getFormId');
  currentFormData.set('url', window.location.href);

  fetch('', {
    method: 'POST',
    body: currentFormData,
  })
    .then((response) => response.json())
    .then((data) => {
      formIdElement.value = data.formId;
    })
    .catch((error) => {
      console.log('js: Unable to set formid.', error);
    });
}

function showWhenOptionIsSelected(e) {
  const {
    key, obj, showWhenValue, showElement,
  } = e;
  const field = obj[key];

  if (field.elem.value === showWhenValue) {
    showElement.style.display = 'block';
  } else {
    showElement.style.display = 'none';
  }
}

function setupCrmValidation() {
  setFormId();

  // This should be rewriten, but it works for now.
  const firstNameValidation = () => validateInput({ key: 'firstName', obj: crmForm.fields });
  const surnameValidation = () => validateInput({ key: 'surname', obj: crmForm.fields });
  const jobTitleValidation = () => validateInput({ key: 'jobTitle', obj: crmForm.fields });
  const companyNameValidation = () => validateInput({ key: 'companyName', obj: crmForm.fields });
  const emailValidation = () => validateInput({ key: 'email', obj: crmForm.fields });
  const phoneNumberValidation = () => validatePhoneNumber({ key: 'phoneNumber', obj: crmForm.fields });
  const countryValidation = () => validateInput({ key: 'country', obj: crmForm.fields });
  const companyTypeValidation = () => validateInput({ key: 'companyType', obj: crmForm.fields });
  const interestsValidation = () => {
    validateInput({ key: 'interests', obj: crmForm.fields });
    showWhenOptionIsSelected({
      key: 'interests', obj: crmForm.fields, showWhenValue: 'Other', showElement: document.querySelector('.contact-form__item_other'),
    });
  };
  // const messageValidation = () => validateInput({ key: 'message', obj: crmForm.fields });

  crmForm.fields.firstName.elem.addEventListener('focusout', firstNameValidation);
  crmForm.fields.surname.elem.addEventListener('focusout', surnameValidation);
  crmForm.fields.jobTitle.elem.addEventListener('focusout', jobTitleValidation);
  crmForm.fields.companyName.elem.addEventListener('focusout', companyNameValidation);
  crmForm.fields.email.elem.addEventListener('focusout', emailValidation);
  crmForm.fields.phoneNumber.elem.addEventListener('focusout', phoneNumberValidation);
  crmForm.fields.country.elem.addEventListener('focusout', countryValidation);
  crmForm.fields.companyType.elem.addEventListener('focusout', companyTypeValidation);
  crmForm.fields.interests.elem.addEventListener('change', interestsValidation);
  // crmForm.fields.message.elem.addEventListener('focusout', messageValidation);
  crmForm.elem.addEventListener('submit', (e) => {
    // trigger all validations, incase autofill is used and didn't trigger it.
    firstNameValidation();
    surnameValidation();
    jobTitleValidation();
    companyNameValidation();
    emailValidation();
    phoneNumberValidation();
    countryValidation();
    companyTypeValidation();
    interestsValidation();
    // messageValidation();
    submitForm(e, crmForm);
  });
}

function setupNewsletterValidation() {
  const emailValidation = () => validateInput({ key: 'email', obj: newsletterForm.fields });
  newsletterForm.fields.email.elem.addEventListener('focusout', emailValidation);
  newsletterForm.elem.addEventListener('submit', (e) => {
    // trigger all validations, incase autofill is used and didn't
    emailValidation();
    submitForm(e, crmForm);
  });
}

function setRecaptchaValid(newValue) {
  recaptchaValid = newValue;
}

function renderRecaptchaV2() {
  // check if current page needs recaptcha.
  const recaptchaElement = document.querySelector('.g-recaptcha');
  if (!recaptchaElement) {
    return;
  }

  // window.grecaptcha will be available.
  window.grecaptcha.render('g-recaptcha', {
    sitekey: '6LcLligkAAAAAGiF3FQGUyiJPNlOkUsyV3duT07p',
  });
}

function setupRecaptchaCallbacks() {
  // Recaptcha global functions.
  window.crmFormRecaptchaV3Submit = (/* token */) => {
    const button = document.querySelector('.g-recaptcha');
    const form = button.closest('form');
    form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  };

  window.cottonRecaptchaV2Setup = () => {
    renderRecaptchaV2();
  };

  window.crmFormRecaptchaV2Callback = (/* token */) => {
    setRecaptchaValid(true);

    // clear error message if there is one.
    const recaptchaErrorElement = document.querySelector('.js-contact-form__error--recaptcha');
    recaptchaErrorElement.textContent = '';
    recaptchaErrorElement.classList.remove('is-invalid');
  };

  window.crmFormRecaptchaV2ExpiredTest = (/* token */) => {
    setRecaptchaValid(false);
  };
}

function setupForms() {
  const $contactForm = document.querySelector('.js-contact-form');
  if ($contactForm) {
    crmForm = formCrm.initForm();

    // setup Crm phone validation.
    setupContactFormPhoneValidation();

    // setup Crm form validation.
    setupCrmValidation();
  }

  const $newsletterForm = document.querySelector('.js-newsletter-form');
  if ($newsletterForm) {
    newsletterForm = formNewsletter.initForm();

    // setup newsletter form validation.
    setupNewsletterValidation();
  }
}

export default {
  init() {
    // call only once.
    setupRecaptchaCallbacks();
    setupForms();
  },
  reload() {
    renderRecaptchaV2();
    setupForms();
  },
};
